import LandingPage from "./pages/LandingPage";

export default function App() {
  return <LandingPage />;
}
